<script setup lang="ts">
// for merge ce shadow-root styles
defineOptions({
  customOptions: {},
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    type?: "flex";
  }>(),
  {
    type: "flex"
  }
);

const style: Record<string, string> = {};

function setStyle() {
  switch (props.type) {
    case "flex":
    default:
      style.display = "flex";
      style.flexDirection = "row";
      style.justifyContent = "space-between";
      style.alignItems = "center";
  }
}
setStyle();

defineExpose({});
</script>

<template>
  <div
    class="content-space-between"
    :style="style"
  >
    <slot></slot>
  </div>
</template>

<style scoped>
.content-space-between > :nth-child(1) {
  flex: 1 1 auto;
}
.content-space-between > :not(:nth-child(1)) {
  flex: 0 0 auto;
}
</style>
